<div class="event-item m-2 border-l-2 border-l-white flex flex-row items-center">
  <div class="event-item-date ml-2 w-12 flex flex-col text-center">
    @if (!loading) {
      <div class="event-item-date-day text-2xl font-bold">{{ event.startdate | date: 'dd' }}</div>
      <div class="event-item-date-month">{{ event.startdate | date: 'MMM' }}</div>
    } @else {
      <p-skeleton width="3rem" height="4rem" />
    }
  </div>
  <div class="event-item-information ml-4 mr-auto flex flex-col w-1/2">
    @if (!loading) {
      <div class="event-item-title text-xl mt-auto">{{ event.name }}</div>
      <div
        class="event-item-location text-sm text-neutral-400 mb-auto overflow-hidden whitespace-nowrap text-ellipsis"
      >
        {{ location }}
      </div>
    } @else {
      <p-skeleton width="9rem" height="1.7rem" class="mb-auto" />
      <p-skeleton width="9rem" height="1.7rem" class="mt-auto" />
    }
  </div>
  @if (!loading) {
    <p-button
      class="ml-auto"
      [rounded]="true"
      [text]="true"
      (onClick)="buttonClicked()"
    >
      <mat-icon color="white">arrow_forward_ios</mat-icon>
    </p-button>
  } @else {
    <p-skeleton width="4rem" height="4rem" class="m-auto" />
  }
</div>
